export const UTM_COOKIE_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "gclid",
  "fbclid",
  "msclkid",
];

export const UTM_TO_GA_CAMPAIGN: Record<string, string> = {
  utm_source: "source",
  utm_medium: "medium",
  utm_campaign: "name",
  utm_term: "term",
  utm_content: "content",
};
